export default __webpack_public_path__ + "static/media/logout.5f59e81e.svg";